import { DepartmentPermissionActionTypes, DepartmentPermissionActions } from "../../actionTypes/permissions/departmentPermissionTypes";



export const getDepartmentPermissionList = (payload: any): DepartmentPermissionActionTypes => ({
  type: DepartmentPermissionActions.GET_DEPARTMENT_PERMISSION_LIST,
  payload
});

export const setDepartmentPermissionList = (payload: any): DepartmentPermissionActionTypes => ({
  type: DepartmentPermissionActions.SET_DEPARTMENT_PERMISSION_LIST,
  payload
})

export const setDepartmentPermissionListCount = (payload: number): DepartmentPermissionActionTypes => ({
  type: DepartmentPermissionActions.SET_DEPARTMENT_PERMISSION_PAGE_COUNT,
  payload
})

export const addDepartmentPermission = (payload: any): DepartmentPermissionActionTypes => ({
  type: DepartmentPermissionActions.ADD_DEPARTMENT_PERMISSION,
  payload
})